export { PD6630_HOMEPAGE_RESTAURANTS_FLAG } from './flag';
export { default as PD6630HomepageRestaurants } from './PD6630HomepageRestaurants';
export { default as PD6630HowItWorks } from './PD6630HowItWorks';
export { default as PD6630HowItWorksHeading } from './PD6630HowItWorksHeading';
